var map = {
	"./1.jpg": "7787",
	"./2.jpg": "d5c2",
	"./3.jpg": "4de1",
	"./4.jpg": "12c4",
	"./5.jpg": "8a89",
	"./6.jpg": "aa26",
	"./7.jpg": "2098",
	"./8.jpg": "1e95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d89";